import type {
  InferContractRouterInputs,
  InferContractRouterOutputs,
} from "@orpc/contract";
import type { contractRouter } from "../contracts";

/**
 * Infer all input types from the contract router
 */
export type ContractInputs = InferContractRouterInputs<typeof contractRouter>;

/**
 * Infer all output types from the contract router
 */
export type ContractOutputs = InferContractRouterOutputs<typeof contractRouter>;

// Convenience type exports for common procedures
export type HealthCheckInput = ContractInputs["health"]["check"];
export type HealthCheckOutput = ContractOutputs["health"]["check"];

// Re-export common schemas
export * from "../schemas/common";
